module.exports = __webpack_public_path__ + "img/user-cowboy.cc67498d.svg";